import { render } from "./paperCategory.vue?vue&type=template&id=232d7fd4&scoped=true"
import script from "./paperCategory.vue?vue&type=script&lang=js"
export * from "./paperCategory.vue?vue&type=script&lang=js"

import "./paperCategory.vue?vue&type=style&index=0&id=232d7fd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232d7fd4"]])

export default __exports__